import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { operationApi } from '../services/operation';
import { sessionApi } from '../services/session';
import { setLoadingState, loadSession, loadFlexParams, setLoaderType } from '../reducers/session';
import { loadIntegrations } from '../reducers/integrations';
import { selectPayload } from '../reducers/flexConfiguration';
import { loadOperation } from '../reducers/operation';
import { loadList } from '../reducers/methodsList';
import { loadPaymentMethod } from '../reducers/paymentMethod';
import { setTranslations } from '../reducers/translations';
import { setMessagesI18n } from '../reducers/messagesI18n';
import { setLanguageMode, setDefaultLanguage, setLanguages, setLanguage } from '../reducers/language';

export const sessionMiddleware = createListenerMiddleware();

sessionMiddleware.startListening({
    matcher: isAnyOf(
      sessionApi.endpoints.createSession.matchPending,
      sessionApi.endpoints.createFlexSession.matchPending,
      ),
    effect: (action, listenerApi) => {
      console.info({onCreateSessionPending: action});
      listenerApi.dispatch(setLoadingState());
    }
});

sessionMiddleware.startListening({
    matcher: sessionApi.endpoints.createSession.matchFulfilled,
    effect: (action, listenerApi) => {
      console.info({onCreateSessionFulfilled: action});
      listenerApi.dispatch(loadSession(action.payload.id));
      listenerApi.dispatch(loadFlexParams(action.payload.flex_params));
      listenerApi.dispatch(loadIntegrations(action.payload.integrations));
    }
});

sessionMiddleware.startListening({
    matcher: sessionApi.endpoints.createFlexSession.matchFulfilled,
    effect: (action, listenerApi) => {
      console.info({onCreateFlexSessionFulfilled: action});
      listenerApi.dispatch(loadSession(action.payload.session_id));
      listenerApi.dispatch(loadFlexParams(action.payload.flex_params));
      listenerApi.dispatch(loadIntegrations(action.payload.integrations));
      listenerApi.dispatch(loadOperation(action.payload));
      listenerApi.dispatch(loadList(action.payload.payment_methods));
      listenerApi.dispatch(loadPaymentMethod(action.payload.method_selected));
      if (action.payload.translations) {
        listenerApi.dispatch(setTranslations(action.payload.translations));
      }
      if (action.payload.messages_i18n) {
        listenerApi.dispatch(setMessagesI18n(action.payload.messages_i18n));
      }
      if (action.payload.i18n_settings) {
        const { mode, default: defaultLang, languages } = action.payload.i18n_settings;
        if (mode) listenerApi.dispatch(setLanguageMode(mode));
        if (defaultLang) {
          listenerApi.dispatch(setDefaultLanguage(defaultLang));
          listenerApi.dispatch(setLanguage(defaultLang));
        }
        if (languages) listenerApi.dispatch(setLanguages(languages));
      }
      setTimeout(()=>{
        listenerApi.dispatch(setLoaderType("boxed"));
      }, 1000);
    }
});
/*
sessionMiddleware.startListening({
    actionCreator: loadSession,
    effect: (action, listenerApi) => {
      console.info({onLoadSession: action});
      listenerApi.dispatch(
        operationApi.endpoints.createOperation.initiate(
            selectPayload(listenerApi.getState())
          )
        );
    }
});
*/